import { useEffect } from 'react';
import { set as setCookie } from 'js-cookie';
import { YAKIT_FORCE_SET_HOSTNAME_COOKIE_NAME } from './const';
import { useExtendSearchParams } from '../../hooks';

export const HostnameOverrideCookies = ({ env = '' }) => {
    const { searchParams, setSearchParams } = useExtendSearchParams();
    const hostnameParam = searchParams.get(YAKIT_FORCE_SET_HOSTNAME_COOKIE_NAME);

    useEffect(() => {
        if (!hostnameParam) {
            return;
        }

        if (env !== 'development') {
            return;
        }

        setCookie(YAKIT_FORCE_SET_HOSTNAME_COOKIE_NAME, hostnameParam);

        setSearchParams(newSearchParams => {
            newSearchParams.delete(YAKIT_FORCE_SET_HOSTNAME_COOKIE_NAME);

            return [newSearchParams];
        });

        location.reload();
    }, [hostnameParam, setSearchParams, env]);

    return null;
};
